module.exports = __webpack_public_path__ + "img/TBB2.4e1747b1.png";